import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const CategoryCreateContent = lazy(() => import('../../../components/Pages/Categories/Create'));

export default function CategoryCreate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Tipping category create`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <CategoryCreateContent />
      </Suspense>
    </Layout>
  );
}
